import http from 'hub-http/clients/apiClient';
import { createInvoiceServiceRequest } from 'invoices-ui-lib/utils/invoiceService';
export const getCreateAndEditValidation = invoice => http.post('invoices/v1/validation/with-associated-objects/create', {
  data: createInvoiceServiceRequest(invoice)
}).then(response => response);